import { AuthContext } from '@/store';
import { useNodeProps } from '@/node-editor/hooks';
import { INode, INodeProps } from '@/types/node';
import { Box, Typography } from '@mui/material';
import { useTheme, Theme } from '@mui/material/styles';
import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react';
import { IContent } from './contract';

interface INodeExtended extends Omit<INode, 'content'> {
  content: IContent;
}

interface IProps extends Omit<INodeProps, 'node'> {
  node: INodeExtended;
}

interface IContainerStyleProps {
  override: Record<string, any>;
}

const useContainerStyles = (
  theme: Theme,
  { override }: IContainerStyleProps
) => ({
  root: {
    width: '100% !important',
    padding: `${theme.spacing(1)} !important`,
    textAlign: 'center !important',
    ...override.root,
  },
  rqimg: {
    width: '100% !important',
    maxWidth: '592px !important',
    height: 'auto !important',
    borderRadius: '5px !important',
    overflow: 'hidden !important',
  },
});

export const Render = ({
  node: {
    id,
    override,
    content: {},
  },
}: IProps) => {
  const theme = useTheme();
  const classes = useContainerStyles(theme, {
    override,
  });
  const { authState } = useContext(AuthContext);
  const [pretixData, setPretixData] = useState<any>({});
  const [error, setError] = useState<string>('');

  const fetchPretixData = () => {
    axios
      .get(`/api/mypretixdata`)
      .then((response) => {
        const data = response.data;
        setPretixData(data);
      })
      .catch((error) => {
        setError(error.response.data.message);
      });
  };

  useEffect(() => {
    authState.userLoggedIn && fetchPretixData();
  }, [authState.userLoggedIn]);

  return (
    <Box sx={classes.root} {...useNodeProps(id)}>
      {authState.user
        ? pretixData?.qr && (
            <Box>
              <Box component="img" sx={classes.rqimg} src={pretixData.qr} />
            </Box>
          )
        : 'Need to be logged in, and have a ticket to see this information.'}

      {error && <Typography color="error">{error}</Typography>}
    </Box>
  );
};
